import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { getMethod } from "../../../utils/api-service/api-service";
import { useState } from "react";

const BlogDetails = () => {

    const { id } = useParams();
    const [blog, setBlog] = useState(null);

    useEffect(() => {
        fetchBlog();
    }, []);

    const fetchBlog = async () => {

        const res = await getMethod(`/blog/${id}`);

        if (res.success) {
            setBlog(res?.blog);
        }
    };

    if (!blog) return <div className="text-center py-5">Loading...</div>;

    return (
        <div className="container py-4">

            <div className="card">
                <div className="card-body">

                    <h2>{blog.title}</h2>

                    <p className="text-muted">
                        By {blog.author}
                    </p>

                    <div
                        className="blog-content"
                        dangerouslySetInnerHTML={{ __html: blog.description }}
                    />

                    {blog.image?.url && (
                        <img
                            src={`${process.env.REACT_APP_API_URL}${blog.image.url}`}
                            alt="blog"
                            className="img-fluid mb-3"
                        />
                    )}

                    {/* <p>{blog.content}</p> */}
                    <div
                        className="blog-content"
                        dangerouslySetInnerHTML={{ __html: blog.content }}
                    />

                </div>
            </div>

        </div>
    );
};

export default BlogDetails;